import { render } from "./WhatMakesUsDifferent.vue?vue&type=template&id=14cd5ee4&ts=true"
import script from "./WhatMakesUsDifferent.vue?vue&type=script&lang=ts"
export * from "./WhatMakesUsDifferent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__